// Shadows tema-aware centralizadas. Antes cada arquivo tinha sua propria
// box-shadow hardcoded com rgba(0,0,0,0.05) — opacidade tao baixa que
// some no dark mode (fundo ja e quase preto). Aqui exportamos helpers
// que retornam o valor certo conforme props.theme.title.
//
// Uso em styled-components:
//   import { cardShadow } from '../themes/shadows';
//   const MyCard = styled.div`
//     box-shadow: ${cardShadow};
//   `;
//
// Os helpers recebem props automaticamente quando referenciados na
// template string.

const isLight = (props) =>
  props.theme && props.theme.title === 'light';

// Cards/paineis: estilo X/Twitter nao usa drop shadow em conteudo
// inline — a separacao vem da borda 1px sobre o fundo do card.
// Retornar 'none' achata tudo ao mesmo plano visual.
export const cardShadow = () => 'none';

// Popovers/dropdowns: precisam destaque mas leve. Mantemos uma sombra
// curta pra indicar elevacao acima do conteudo do card.
export const popoverShadow = (props) =>
  isLight(props)
    ? '0 2px 8px rgba(0, 0, 0, 0.06)'
    : '0 2px 8px rgba(0, 0, 0, 0.32)';

// Modais sobre overlay — destaque mais forte pra separar do fundo
// escurecido.
export const modalShadow = (props) =>
  isLight(props)
    ? '0 8px 28px rgba(0, 0, 0, 0.18)'
    : '0 8px 28px rgba(0, 0, 0, 0.50)';

// Chips/legendas flutuantes sobre o mapa.
export const overlayShadow = (props) =>
  isLight(props)
    ? '0 2px 8px rgba(0, 0, 0, 0.10)'
    : '0 2px 8px rgba(0, 0, 0, 0.35)';
